import axios from "../interceptors";
import { API_PROTECTED_PATH, API_PUBLIC_PATH, API_URL_PRD } from "../config/config";
import { reqHeader_protected, reqHeader_public } from "../headers";
import { getStorageAuthToken } from "../../utils/token";
import qs from "qs";
import { useLocation } from "react-router-dom";
import { useEffect, useState } from "react";
import {
  pfidClientID,
  pfidConnectionUrl,
  pfidCreateAccountUrl,
  pfidGetTokenUrl,
} from './settings';
import ApiClient from "../requests";

export async function deleteUserRemoteData({ lang }) {
  const _authToken = getStorageAuthToken();
  return axios.post(`${API_URL_PRD}${API_PROTECTED_PATH}user/delete`, null, {
    //@ts-ignore
    ...reqHeader_protected(_authToken),
    params: { lang },
  });
}

export async function loginUser(payload) {
  console.log("LOGIN data: ", payload);
  const uid = "deviceId";
  let data: any = { device_id: uid };
  if (payload.token) {
    data = {
      token: payload.token,
    };
  } else {
    data = {
      email: payload.user,
      password: payload.pass,
    };
  }

  const urlencode = qs.stringify(data);

  const Url = `${API_URL_PRD}${API_PUBLIC_PATH}user/login`;
  console.log("LOGIN data 2: ", urlencode, Url, uid);

  return new Promise((resolve, reject) => {
    axios
      .post(Url, urlencode, reqHeader_public)
      .then((result) => {
        console.log("checkUserInfo response: ", result)
        resolve(result.data);
      })
      .catch((error) => {
        console.log("login user : Axios call error: ", JSON.stringify(error));
        reject({ msg: error.message });
      });
  });
}

export async function createUser(payload) {
  const url = `${API_URL_PRD}${API_PUBLIC_PATH}user/register`;

  return new Promise((resolve, reject) => {
    axios
      .post(url, payload, reqHeader_public)
      .then((result) => {
        resolve(result.data);
      })
      .catch((error) => {
        console.log(
          "createuser user : Axios call error: ",
          JSON.stringify(error)
        );
        console.log(" ERROR [createuser] : ", error.response);
        reject({ msg: error.message });
      });
  });
}



// utils
function base64URLEncode(str) {
  return btoa(str)
    .replace(/\+/g, '-')
    .replace(/\//g, '_')
    .replace(/=/g, '');
}
function bufferToString(buffer: any) {
  const CHARSET = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
  const state: string[] = [];
  for (let i = 0; i < buffer.byteLength; i += 1) {
    const index = buffer[i] % CHARSET.length;
    state.push(CHARSET[index]);
  }
  return state.join('');
}

// generate the code_verifier
export function generateCodeVerifier() {
  const array = new Uint8Array(32);
  window.crypto.getRandomValues(array);
  return base64URLEncode(bufferToString(array));
}

// generate the code_challenge
export async function generateCodeChallenge(codeVerifier: string) {
  const encoder = new TextEncoder();
  const data = encoder.encode(codeVerifier);
  const buffer = await window.crypto.subtle.digest('SHA-256', data);
  //@ts-ignore
  const bufferString = String.fromCharCode.apply(null, new Uint8Array(buffer));
  return base64URLEncode(bufferString);
}

export function setCodeVerifier(code: string) {
  localStorage.setItem('codeVerifier', code);
}
export function getCodeVerifier() {
  return localStorage.getItem('codeVerifier');
}


// }
// export async function signIn(){
//   fetch('https://am-stg.pierre-fabre.io/hcp/oauth/token', {
//     method: 'POST',
//     headers: {
//       'Authorization': 'Basic |base64 encoded peer client_id:client_secret|',
//       'Content-Type': 'application/x-www-form-urlencoded'
//     },
//     body: 'grant_type=authorization_code&code=|code|&redirect_uri=[https://pp.pierrefabrefor\nmed.com%26client_id%3D0e36294e-b3c4-4b7d-b629-\n4eb3c42b7d02%26code_verifier%3D%7Cverifier%7C%27/]https://pp.pierrefabrefor\nmed.com&client_id=0e36294e-b3c4-4b7d-b629-\n4eb3c42b7d02&code_verifier=|verifier|'
//   });
// }

